var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: "legal_entities.create",
              expression: "'legal_entities.create'",
            },
            {
              name: "ripple",
              rawName: "v-ripple.400",
              value: "rgba(255, 255, 255, 0.15)",
              expression: "'rgba(255, 255, 255, 0.15)'",
              modifiers: { 400: true },
            },
          ],
          attrs: { variant: "primary" },
          on: { click: _vm.addNew },
        },
        [
          _c("feather-icon", {
            staticClass: "mr-50",
            attrs: { icon: "PlusIcon" },
          }),
          _c("span", { staticClass: "align-middle" }, [
            _vm._v(_vm._s(_vm.$t("AddNew"))),
          ]),
        ],
        1
      ),
      _c("Grid", {
        attrs: {
          css_formats: _vm.gridCssFormats(),
          service: _vm.service,
          forceFilters: { person_type: "LE" },
          route_name: "legal_entities",
        },
        scopedSlots: _vm._u([
          {
            key: "gridThead",
            fn: function (thead) {
              return _vm._l(thead.data, function (column, key) {
                return _c(
                  "vs-th",
                  {
                    key: key,
                    attrs: {
                      "sort-key": thead.methods.getColumnSortKey(key),
                      "sort-status": "asc",
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "establishment." +
                            thead.methods.getOriginalColumnName(column)
                        )
                      )
                    ),
                  ]
                )
              })
            },
          },
          {
            key: "gridData",
            fn: function (gridData) {
              return _vm._l(gridData.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _vm._l(gridData.columns, function (column, key) {
                      return _c(
                        "vs-td",
                        {
                          key: key,
                          attrs: { data: gridData.data[indextr].id },
                        },
                        [
                          _c(
                            "div",
                            {
                              class: gridData.methods.getColumnCss(
                                gridData.data[indextr],
                                key
                              ),
                            },
                            [
                              _c("div", {
                                directives: [
                                  {
                                    name: "html-safe",
                                    rawName: "v-html-safe",
                                    value:
                                      "<div>" +
                                      gridData.methods.getColumnData(
                                        gridData.data[indextr],
                                        key
                                      ) +
                                      "</div>",
                                    expression:
                                      "`<div>${gridData.methods.getColumnData(gridData.data[indextr],key)}</div>`",
                                  },
                                ],
                                key: key,
                              }),
                            ]
                          ),
                        ]
                      )
                    }),
                    _c("vs-td", [
                      _c(
                        "div",
                        { staticClass: "flex flex-row gap-2" },
                        [
                          !_vm.hide_edit
                            ? _c("feather-icon", {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "legal_entities.edit",
                                    expression: "`legal_entities.edit`",
                                  },
                                ],
                                staticClass:
                                  "h-5 w-5 stroke-current text-warning",
                                attrs: { icon: "EditIcon" },
                                on: {
                                  click: function ($event) {
                                    return gridData.edit(
                                      gridData.data[indextr].id
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                          !_vm.hide_delete
                            ? _c("feather-icon", {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "legal_entities.delete",
                                    expression: "`legal_entities.delete`",
                                  },
                                ],
                                staticClass:
                                  "h-5 w-5 stroke-current text-danger",
                                attrs: { icon: "Trash2Icon" },
                                on: {
                                  click: function ($event) {
                                    return gridData.destroy(
                                      gridData.data[indextr]
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }